export * from './cy'
export * from './bridge'
export * from './mixpanel'

export enum EventBus {
  DisconnectWallet = 'disconnect-wallet'
}

export enum NoticeBanner {
  UpcomingChainUpgrade = 'upcoming-chain-upgrade'
}

export enum TransferView {
  TransferForm = 'transfer-form',
  TokenSelector = 'token-selector'
}

export enum WormholeTransferView {
  Attest = 'attest',
  Redeem = 'redeem',
  Transfer = 'transfer'
}

export enum CustomAddressView {
  Form = 'custom-address-form',
  Wallets = 'custom-address-wallets'
}

export enum WormholeMigrationView {
  CTA = 'cta',
  Success = 'success',
  Confirm = 'confirm',
  TokenSelector = 'token-selector'
}

export enum BridgeView {
  Confirm = 'confirm',
  History = 'history',
  Success = 'success',
  BridgeForm = 'bridge-form',
  ConvertEth = 'convert-eth',
  TokenSelector = 'token-selector'
}

export enum Page {
  Index = 'index',
  Cctp = 'cctp',
  History = 'history',
  Fiat = 'index-fiat',
  Transfer = 'transfer',
  Wormhole = 'wormhole',
  Bridge = 'index-bridge',
  Maintenance = 'maintenance',
  MemesBridge = 'memes-bridge',
  WormholeMigration = 'wormhole-migration'
}

export enum Modal {
  CustomPeggy = 'custom-peggy',
  WalletQRCode = 'wallet-qr-code',
  GeoRestricted = 'GeoRestricted',
  WalletConnect = 'wallet-connect',
  PendingTransactions = 'pending-transactions',
  WalletConnectFiltered = 'wallet-connect-filtered',
  CustomRecipientAddress = 'custom-recipient-address'
}
